import { Shapes } from '@components/shapes';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { Color } from '@styles/theme';

type Variant =
  | 'success'
  | 'pending'
  | 'error'
  | 'info'
  | 'active'
  | 'skipped'
  | 'default'
  | 'disabled';

const variantColorMap: { [key in Variant]: Color } = {
  success: 'elementGreen200',
  pending: 'elementOrange100',
  error: 'elementRed100',
  info: 'elementIndigo100',
  active: 'elementBlue100',
  skipped: 'elementTeal100',
  default: 'elementPurple100',
  disabled: 'elementPurple50',
};

export type TextStatusIndicatorProps = {
  variant?: Variant;
  text?: string | string[];
};

export const TextStatusIndicator = ({ variant = 'default', text }: TextStatusIndicatorProps) => {
  const color = variantColorMap[variant];

  return (
    <Stack orientation="horizontal" space={2} align="center">
      <Shapes.Circle size={8} color={color} />
      <Text text={text} color={color} font="semibold14" />
    </Stack>
  );
};
